import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import NewSelectorMultiple from '@/pages/dashboard/components/NewSelectorMultiple';
import { ALL_VALUE } from '@/pages/dashboard/components/NewSelectorMultiple/constants';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getCasualOverviewInfo } from '@home/services/studio';
import type { ISubStudioFilterProps } from '@/pages/home/pages/studio/casualHub/components/SubStudioFilter/type';
import './index.scss';

const SubStudioFilter: React.FC<ISubStudioFilterProps> = ({ config, data, changeData, className, style }) => {
  const { isEN } = useLocal();
  const {
    labelEn = 'Sub Studio',
    labelCn = '子工作室',
    allDescribeEn = 'All',
    allDescribeCn = '全部',
    dropdownClassName = '',
  } = config || {};

  const [selfFetchedUnits, setSelfFetchedUnits] = useState<string[]>([]);

  useEffect(() => {
    if (!data?.casualInfo?.studio_business_unit && data?.frameCode) {
      getCasualOverviewInfo({ studio_code: data.frameCode as string }).then((res) => {
        setSelfFetchedUnits(res?.studio_business_unit || []);
      }).catch((err) => {
        console.error('SubStudioFilter getCasualOverviewInfo error:', err);
      });
    }
  }, [data?.frameCode]);

  const rawOptions = data?.casualInfo?.studio_business_unit || selfFetchedUnits;
  const options = rawOptions.map(s => ({ value: s, text: s }));

  const [value, setValue] = useState<string[]>([ALL_VALUE]);

  const handleChange = (values: string[]) => {
    setValue(values);
  };

  const handleClose = () => {
    changeData?.('subStudioFilter', value);
  };

  return (
    <div className={classNames('dbh-casual-sub-studio-filter', className)} style={style}>
      <NewSelectorMultiple
        label={isEN ? labelEn : labelCn}
        allDescribe={isEN ? allDescribeEn : allDescribeCn}
        options={options}
        value={value}
        matchButtonWidth
        className={dropdownClassName}
        onChange={handleChange}
        onClose={handleClose}
      />
    </div>
  );
};

export default SubStudioFilter;
